import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=499f5a58&"
import script from "./MainPage.js?vue&type=script&lang=js&"
export * from "./MainPage.js?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports